import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Company/MembershipRegulations/components/SectionRequirements/SectionRequirements.module.scss';

const cn = classNames.bind(styles);

const SectionRequirements = (): ReactElement => {
  return (
    <section className={cn('requirements')}>

        <div className={cn('requirements__content')}>
          <div className={cn('requirements__paragraphs')}>
            <p className={cn('requirements__paragraph')}>
              * You need to submit an application and fill out a KYC form. Upon completion, we will review your
              candidacy for membership, and DP World's respective board will decide whether the applicant will be
              accepted or not.
            </p>
            <p className={cn('requirements__paragraph')}>
              * You can apply for no more than 3 locations in one country unless otherwise decided in particular cases
            </p>
          </div>
        </div>

    </section>
  );
};

export default SectionRequirements;